import React from "react";
import MemberCard from "./MemberCard";
import naseem from "../../images/members/naseem.jpg";
import hamayon from "../../images/members/hamayon.jpg";
import atiq from "../../images/members/atiq.jpg";
import kasem from "../../images/members/kasem.jpg";
import aisha from "../../images/members/aisha.jpg";

const OurTeam = () => {
  const teamMembers = [
    { name: "Aisha Hakimi", position: "Manager", image: aisha, delay: 100 },
    { name: "Atiq Rahin", position: "Treasurer", image: atiq, delay: 200 },
    { name: "Hamayon Ibrahim", position: "Secretary", image: hamayon, delay: 300 },
    { name: "Naseem Yar", position: "Board Member", image: naseem, delay: 400 },
    { name: "Kasem Gardezi", position: "Board Member", image: kasem, delay: 500 }
  ];

  return (
    <div className="ourTeam" data-aos="fade-up">
      <h1 data-aos="fade-down" data-aos-delay="100">Board of Directors</h1>
      <div className="teamPhotos">
        {teamMembers.map((member, index) => (
          <div 
            key={index} 
            className="card"
            data-aos="zoom-in"
            data-aos-delay={member.delay}
          >
            <MemberCard 
              name={member.name} 
              position={member.position} 
              imageURL={member.image} 
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurTeam;